import React, { useState } from 'react';
import { IconButton, Popover, Paper, Typography, TextField } from '@mui/material';
import { Message } from '@mui/icons-material';

interface GuaranteeObservationWithHoverProps {
  guaranteeObservation?: string;
  guaranteeAmount: number;
  hasError?: boolean;
}

const GuaranteeObservationWithHover: React.FC<GuaranteeObservationWithHoverProps> = ({
  guaranteeObservation,
  guaranteeAmount,
  hasError = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl) && guaranteeAmount > 0 && !!guaranteeObservation;
  const isDisabled = guaranteeAmount <= 0;

  return (
    <div
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      <IconButton
        disabled={isDisabled}
        color={hasError ? 'error' : undefined}
      >
        <Message />
      </IconButton>
      
      <Popover
        id="guarantee-observation-popover"
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Paper
          style={{
            padding: 20,
            minWidth: 300,
            maxHeight: 400,
            overflow: 'scroll',
          }}
        >
          <Typography variant="body1" style={{ marginBottom: 8 }}>
            Observación monto en garantía
          </Typography>
          <TextField
            value={guaranteeObservation || 'Sin observación'}
            type="text"
            fullWidth
            disabled
            multiline
            rows={3}
            placeholder="Sin observación"
            InputProps={{ style: { backgroundColor: '#f5f5f5' } }}
            sx={{ marginBottom: 1 }}
          />
        </Paper>
      </Popover>
    </div>
  );
};

export default GuaranteeObservationWithHover;